export default __webpack_public_path__ + "static/media/arcos1_c.17fa38e6.jpg";